export const AUTHORITIES = {
  ROLE_ADMIN: 'Administrador',
  ROLE_STUDENT: 'Estudiante',
  ROLE_TEACHER: 'Profesor',
  ROLE_SUPERVISOR: 'Supervisor',
  ROLE_ENABLING_TEACHER: 'Profesor Habilitador',
  ROLE_ACADEMIC_ADMIN: 'Administrador académico'
};

